export default "__VITE_ASSET__BvKIAHaZ__"